import { render, staticRenderFns } from "./PsychologistDetail.vue?vue&type=template&id=07e4de5b&scoped=true"
import script from "./PsychologistDetail.vue?vue&type=script&lang=js"
export * from "./PsychologistDetail.vue?vue&type=script&lang=js"
import style0 from "./PsychologistDetail.vue?vue&type=style&index=0&id=07e4de5b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e4de5b",
  null
  
)

export default component.exports